export default __webpack_public_path__ + "static/media/House-Boat.7b464685.jpg";